import React from 'react';
import { LoyaltyPageContent } from 'acscp/components/loyalty/loyaltyPageContent';
import { HeaderSplashImage, PageHeader } from 'acscp/components/common/pageHeader';
import { withPageLayout } from 'acscp/components/layout/pageLayout';
import { FormattedMessage } from 'react-intl';
import { Route } from 'react-router-dom';
import { TransactionHistoryModal } from '../loyalty/transactionHistoryModal';

const LoyaltyPage: React.SFC<{}> = () => {
    return (
        <div>
            <PageHeader
                title={
                    <FormattedMessage
                        id={'components.pages.loyalty.title'}
                        defaultMessage={'MY REWARDS'}
                    />
                }
                splashImage={HeaderSplashImage.People}
            />
            <LoyaltyPageContent />
            <Route path="/loyalty/transaction-history" exact={true} render={() => <TransactionHistoryModal />} />
        </div>
    );
};

const Loyalty = withPageLayout(LoyaltyPage);
export { Loyalty, LoyaltyPageContent };
